import { HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

/**
 * Small, pure utilities extracted from CommonService.
 * Intentionally preserve prior behavior (simple string concatenation).
 */

export function buildApiUrl(apiPath: string): string {
  return `${environment.apiURL}${apiPath}`;
}

export function buildBodyRequestOptions(params: {
  headers: HttpHeaders | undefined;
  responseType?: any;
  options?: any;
}): any {
  const { headers, responseType, options } = params;
  return responseType
    ? { headers, responseType }
    : options
      ? options
      : { headers };
}

